import "./App.css";

import { DataHandler } from "./DataHandler";
import ReactAudioPlayer from 'react-audio-player';
import { useState } from "react";

function App() {
  const [name, setName] = useState(""); // State to hold the input value
  const [response, setResponse] = useState(""); // State to hold the response message

  return (
    <div className="App">
          
      <DataHandler>
        <ReactAudioPlayer         
          autoPlay
          controls
        />
      </DataHandler>
    </div>
  );
}

export default App;